import React from "react";
import CharityModal from "./CharityModal";
import { createCharity } from "../../api/charityApi";

const CreateCharityModal = ({ open, onClose, onSuccess }) => {
  const handleSave = async (payload) => {
    try {
      await createCharity(payload);
      onSuccess?.();
      onClose();
    } catch (err) {
      console.error("Failed to create charity:", err);
      // error shown globally via axios interceptor → toast
    }
  };

  return (
    <CharityModal
      open={open}
      onClose={onClose}
      onSave={handleSave}
      mode="create"
    />
  );
};

export default CreateCharityModal;
